var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-left as-content px__18",class:{ expanded: _vm.expand },staticStyle:{"height":"100%"}},[_c('v-row',{staticClass:"mx-0 mt-0 font__14"},[_c('v-col',{staticClass:"pa-3",attrs:{"cols":"12"}},[_c('span',[_vm._v(" "+_vm._s(_vm._f("translate")('재고 변경 이력 보기'))+" ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }